import enTranslations from './en.js';
import plTranslations from './pl.js';

export default {
  'en': enTranslations,
  'pl': plTranslations
};



// WEBPACK FOOTER //
// ./src/langs/loader.js